import React from 'react';
import { Components } from './styled';

const ProjectSimpleContainer = ({ children }: { children?: React.ReactNode }) => {
  return <Components.Container>{children}</Components.Container>;
};

export default ProjectSimpleContainer;
